
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TripCountIcon from '@components/icons/summary/icon-trip-count.svg';
import DistanceIcon from '@components/icons/summary/icon-distance.svg';
import DurationIcon from '@components/icons/summary/icon-duration.svg';
import SpeedIcon from '@components/icons/summary/icon-tachometer.svg';
import TripStatisticBarItem from '@components/new-styleguide/TripStatisticBarItem.vue';
import {isNullOrUndefined} from "util";

@Component({
  name: 'TripStatisticBar',
  components: {
    TripStatisticBarItem,
    DistanceIcon,
    DurationIcon,
    SpeedIcon,
    TripCountIcon
  },
})
export default class TripStatisticBar extends Vue {
  @Prop()
  private tripCount: number;

  @Prop()
  private distance: number;  // km

  @Prop()
  private duration: number;  // minutes

  @Prop()
  private speed: number;  // km/h

  @Prop({ default: false })
  private loading: boolean;

  @Prop({ default: false })
  private showLoadingSpeed: boolean;

  get formattedDistance() {
    return this.loading ? '---' : Math.round(this.distance);
  }

  get formattedDuration() {
    return this.loading ? '---' : String(this.duration);
  }

  get formattedTripCount() {
    return this.loading ? '---' : this.tripCount;
  }

  get formattedSpeed() {
    return this.loading ? '---' : String(Math.round(this.speed));
  }

  get loadingWithoutSpeed() {
    return this.loading && !this.showLoadingSpeed;
  }

  get loadingWithSpeed() {
    return this.loading && this.showLoadingSpeed;
  }

  created() {
    if (!this.loading) {
      if (!this.tripCount && !this.speed && this.tripCount !== 0 && this.speed !== 0) {
        throw Error('tripCount or speed expected');
      }

      if (this.tripCount && this.speed) {
        throw Error('only one of tripCount or speed expected, not both');
      }

      if (!this.distance && this.distance !== 0) {
        throw Error('Distance expected');
      }

      if (!this.duration && this.duration !== 0) {
        throw Error('Duration expected');
      }
    }
  }

  private isNotNullAndUndefined(value: number) {
    return !isNullOrUndefined(value);
  }
}
